import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import marcaService from '../../../service/administracion/marcaService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            filter: {
                nombre: '',
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: ''
        };
    };

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            estado: '',
            ...FILTER
        };

        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await marcaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Marca.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await marcaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Marca.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await marcaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await marcaService.eliminar(values);
            else
                response = await marcaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        this.setState({ visible: true, formValues });
    };


    handleEdit = async (values) => {
        const response = await marcaService.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombre: response.nombre,
                    codigo: response.codigo

                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await marcaService.registrar(values);
            else
                response = await marcaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, marcaService.paginacion);
    }

    render() {
        return (
            <div>
                <Header
                    title="Marca"
                    onNew={this.handleNew}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}